import { BrandKit } from "@redotech/redo-content-builder-common/brand-kit";
import { SignupForm as ISignupForm } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import { memo } from "react";
import { BaseSignupForm } from "./base-signup-form";
import { SignupFormContainer } from "./signup-form-container";

export const SignupForm = memo(function SignupFormModal({
  form,
  brandKit,
  currentStep,
  discountCode,
  merchantPhoneNumber,
  anonymousId,
  onSubmitStep,
  onClose,
  onCreatePendingTextToSubscribeRecord,
}: {
  form: ISignupForm;
  brandKit: BrandKit;
  currentStep: number;
  discountCode?: string;
  merchantPhoneNumber?: string;
  anonymousId?: string;
  onSubmitStep: (_: {
    stepIndex: number;
    formData: Record<string, string>;
    shouldAdvance?: boolean;
  }) => Promise<void>;
  onClose?: () => void;
  onCreatePendingTextToSubscribeRecord?: () => Promise<string | undefined>;
}) {
  return (
    <SignupFormContainer form={form} onClose={onClose} previewMobile={false}>
      <BaseSignupForm
        anonymousId={anonymousId}
        brandKit={brandKit}
        currentStep={currentStep}
        discountCode={discountCode}
        form={form}
        merchantPhoneNumber={merchantPhoneNumber}
        onClose={onClose}
        onCreatePendingTextToSubscribeRecord={
          onCreatePendingTextToSubscribeRecord
        }
        onSubmitStep={onSubmitStep}
      />
    </SignupFormContainer>
  );
});
